module.exports = __webpack_public_path__ + "static/media/logo.3359ae73.png";